import { useCallback } from "react";
import axios from "axios";
import { Urls } from "../../App";

export const useStatusToVerifyService = () => {
  //const baseURL = "https://devapi.maxlifeinsurance.com/acr"; //dev
  //  const baseURL = "https://uatapi.maxlifeinsurance.com/acr"; //uat
  const { baseURL, APIKey } = Urls();
  const URl = baseURL;

  const headers = {
    "Content-Type": "application/json",
    //"x-api-key": "U1HQLHNvZO8ewIKnaZEIv95fvF4zDfEu3h9aLuAI", //dev
    "x-api-key": APIKey, //uat
    // Token:
    //   "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxIiwiaWF0IjoxNzMzNzUwNzY2LCJleHAiOjE3MzM3NTQzNjZ9.vGMb3FvYKEx0yswPQrG-sf45R48EWWg828UHX3pOS6O3EM57lBobIYM7zE_NCEQeXLEC965OfV5p_VZ2f4fK7g",
  };
  const getStatusOfUser = useCallback(
    async (data, accessToken) => {

      try {
        const response = await axios.post(
          `${URl}/api/journey/status`,

          data,
          {
            headers: {
              ...headers,
              Token: `Bearer ${accessToken}`,
            },
          }
        );

        return response.data;
      } catch (error) {
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return { getStatusOfUser };
};
